import { IconX } from "@tabler/icons-react";
import styles from "./SupportModal.module.css";

const ICON_CLASS = {
  red: styles.iconRed,
  blue: styles.iconBlue,
  amber: styles.iconAmber,
};

export default function ModalShell({
  open,
  onClose,
  icon: Icon,
  color = "#0a0e5c",
  title,
  subtitle,
  children,
  footer,
}) {
  if (!open) return null;

  return (
    <div
      className={styles.overlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            {Icon && (
              <div
                className={`${styles.icon} ${ICON_CLASS[color] || ICON_CLASS.blue}`}
              >
                <Icon size={20} />
              </div>
            )}
            <div>
              <div className={styles.title}>{title}</div>
              {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            </div>
          </div>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close"
          >
            <IconX size={17} />
          </button>
        </div>

        <div className={styles.body}>{children}</div>

        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
